/*
	许可证激活入口文件
 */

// 引入Vue框架
import Vue from "vue";
// 引入许可证激活组件
import license from './License.vue'

const LicenseClass = Vue.extend(license);

export default (options = {}) => {
	const licenseInstance = new LicenseClass({
		data: options,
	});
	document.body.appendChild(licenseInstance.$mount().$el);
};
